<script lang="ts">
const factorEffect = 200
</script>
<template>
  <transition
    appear
    mode="out-in"
    @before-enter="onBeforeEnter"
    @enter="onEnter"
    @leave="onLeave"
    @after-leave="onAfterLeave"
    @leave-cancelled="onLeaveCancelled"
  >
    <div v-if="motionKey !== 'empty'" :key="motionKey" class="dialog-motion">
      <slot />
    </div>
  </transition>
</template>
<script lang="ts" setup>
// @ts-ignore
import { spring } from 'vue3-spring';
import { gsap } from 'gsap';
interface Props {
  motionKey: string | number;
  position?: 'center' | 'top-right';
}
const props = defineProps({
  motionKey: null,
  position: { default: 'center' }
});
const isLeaving = ref<boolean>(false);
const emit = defineEmits(["enter", "leave"]);

const transform = ref(0.9 * factorEffect);
const effect = spring(transform, {
  stiffness: 400,
  damping: 14,
  mass: 0.8,
  precision: 1,
});

const element = ref(null);

const breakpoints = useEvaBreakpoints();
const isAboveL = breakpoints.greaterOrEqual('l');

const onBeforeEnter = (el) => {
  element.value = el;
};
const onEnter = (el, done) => {
  isLeaving.value = false;
  transform.value = 1 * factorEffect;
  gsap.set(el, { opacity: 0 });
  gsap.to(el, { opacity: 1, ease: 'quad.in', duration: 0.15 });
  if (props.position === 'top-right' && isAboveL.value) {
    gsap.set(el, { transformOrigin: '90% 10%' });
  } else {
    gsap.set(el, { transformOrigin: '50%' });
  }
  setTimeout(() => {
    done();
    emit('enter');
  }, 1000);
};

const onLeave = (el, done) => {
  isLeaving.value = true;
  const tl = gsap.timeline({
    onComplete: () => {
      done();
      emit('leave');
    },
  });
  tl.to(
    el,
    {
      opacity: 0,
      ease: 'quad.in',
      duration: 0.15,
    },
    0.2
  );

  tl.to(
    el,
    {
      scale: 0.6,
      ease: 'back.in',
      duration: 0.4,
    },
    0
  );
};
const onAfterLeave = () => {};
const onLeaveCancelled = () => {};

watch(
  () => effect.value / factorEffect,
  (e) => {
    if (!isLeaving.value && element.value) {
      gsap.set(element.value, { scale: 0.8 + 0.2 * e });
    }
  }
);
</script>
<style lang="scss" scoped>
.dialog-motion {
  display: grid;
  z-index: 1;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  transform-origin: center;
  pointer-events: none;
  @include below('xs') {
    padding: 0 1rem;
  }
  @include above('l') {
    width: 100%;
    padding: 1rem 0;
    &.top-right {
      transform-origin: 0%;
    }
  }
}
</style>
